import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';

/**
 * Texto longo das páginas de app, setor e guia.
 *
 * Link que começa com "/" navega dentro do site sem recarregar; link externo
 * abre em outra aba. Tabela em Markdown vira tabela de verdade, que é o formato
 * que buscadores e assistentes de IA extraem melhor.
 */
export function Prose({ markdown }: { markdown: string }) {
  return (
    <div className="seo-prose">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) =>
            href?.startsWith('/') ? (
              <Link to={href}>{children}</Link>
            ) : (
              <a href={href} target="_blank" rel="noopener">
                {children}
              </a>
            ),
          table: ({ children }) => (
            <div className="seo-table-wrap">
              <table>{children}</table>
            </div>
          ),
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
